function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback } from 'react';
import { useEventTracker, verifyRole, useCurrentUser } from '@applyboard/ui-utils';
import { CreateApplicationButton } from '@applyboard/ab-application';
import { CheckEligibilitySchoolButton } from "../..";
function StudentAndVisitorButton(_ref) {
  var programId = _ref.programId,
    onClick = _ref.onClick,
    eligibility = _ref.eligibility,
    variant = _ref.variant,
    fullWidth = _ref.fullWidth,
    eventTrackingPrefix = _ref.eventTrackingPrefix;
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var handleOnClick = useCallback(function () {
    onClick();
    trackEvent({
      event: "".concat(eventTrackingPrefix, " - Clicked 'Check Student Eligibility'"),
      data: {
        outcome: 'Opened student eligibility modal (Student/Advisor Flow)',
        programId: programId
      }
    });
  }, [trackEvent, onClick, eventTrackingPrefix, programId]);
  return /*#__PURE__*/React.createElement(CheckEligibilitySchoolButton, {
    openModalFn: handleOnClick,
    eligibilityResult: {
      eligibility: (eligibility === null || eligibility === void 0 ? void 0 : eligibility.eligibilityResult) || '',
      recruitment_restricted: eligibility === null || eligibility === void 0 ? void 0 : eligibility.recruitmentRestricted,
      intake_available: eligibility === null || eligibility === void 0 ? void 0 : eligibility.intakeAvailable,
      searchData: eligibility === null || eligibility === void 0 ? void 0 : eligibility.eligibilitySearchData
    },
    programId: Number.parseInt(programId),
    userId: currentUser ? Number.parseInt(currentUser.id) : undefined,
    useUpdatedButtonDesign: true,
    variant: variant,
    fullWidth: fullWidth
  });
}
export function SimplifiedCheckEligibilityButton(props) {
  var _useCurrentUser3 = useCurrentUser(),
    _useCurrentUser4 = _slicedToArray(_useCurrentUser3, 1),
    currentUser = _useCurrentUser4[0];
  var studentAndVisitorButtonProps = _objectSpread(_objectSpread({}, props), {}, {
    onClick: verifyRole.isVisitor(currentUser) ? function () {
      return window.location.assign("/register?redirect_to=".concat(encodeURIComponent(location.pathname)));
    } : props.onClick
  });
  return verifyRole.isStudent(currentUser) || verifyRole.isVisitor(currentUser) ? /*#__PURE__*/React.createElement(StudentAndVisitorButton, studentAndVisitorButtonProps) : /*#__PURE__*/React.createElement(CreateApplicationButton, {
    program: {
      id: props.programId.toString(),
      name: props.programName,
      programLevel: props.programLevel
    },
    school: {
      id: props.schoolId,
      country: props.schoolCountry
    },
    pageName: window.location.pathname.includes('/programs') ? 'Program' : 'School'
  });
}